export default "__VITE_ASSET__0175ff21__"